<template>
    <div class="container mt-4">
        <div class="row">
            <div class="col-md-10 mx-auto">
                <div class="card">
                    <div class="card-body">
                        <div class="row" style="justify-content: center;">
                            <div class="col-3">
                                <button v-if="selectedItems.length == 0" class="btn btn-primary mt-3"
                                    @click="carregarRateiosExistentes">
                                    Carregar
                                </button>
                            </div>
                        </div>
                        <div v-if="exibirElementoRateio">
                            <div v-if="$store.state.item.status == 'criacao'">
                                <!-- Campo de Autocomplete -->
                                <input type="text" class="form-control mb-3" placeholder="Digite para buscar..."
                                    v-model="searchQuery" @input="fetchResults" v-if="nivel_acesso != 'adm'" />

                                <!-- Sugestões -->
                                <ul v-if="searchResults.length > 0" class="list-group">
                                    <li v-for="item in searchResults" :key="item.id"
                                        class="list-group-item list-group-item-action" @click="addToTable(item)">
                                        {{ item.nome }}
                                    </li>
                                </ul>
                            </div>
                            <div class="row mt-3">
                                <div class="col">
                                    <p v-if="$store.state.somaRateio"><b>Soma Rateio: {{
                                        $store.state.somaRateio | formatCurrency }}</b>
                                    </p>
                                </div>
                                <div class="col">
                                    <p><b>Valor Comprovante: {{ $store.state.item.valor_comprovante }}</b></p>
                                </div>
                                <div class="col">
                                    <button type="button" class="btn btn-primary btn-sm mb-2 float-end"
                                        @click="exportarXLSX(selectedItems)">
                                        ExportarXLSX
                                    </button>
                                </div>
                            </div>

                            <!-- Tabela com Registros Selecionados -->
                            <div v-if="selectedItems.length > 0" class="mt-4">
                                <button type="button" v-if="$store.state.item.status == 'criacao'"
                                    class="btn btn-primary btn-sm mb-2 float-end" @click="statusLancamentoRat()">
                                    Enviar Lançamento
                                </button>
                                <h5>Registros Selecionados</h5>
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>Código Reduzido</th>
                                            <th>Valor Rateio</th>
                                            <th v-if="$store.state.item.status == 'criacao'">Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in selectedItems" :key="item.id" :style="styleRateio">

                                            <td>{{ item.nome }}</td>
                                            <td>{{ item.cod_conta_caixa_paciente || item.conta_contabil_reduzido }}</td>
                                            <td>
                                                <input type="text" class="form-control"
                                                    v-model="item.valor_rateio_paciente"
                                                    @input="aplicarMascaraLanRat($event, item)"
                                                    placeholder="Valor Rateio..." />
                                            </td>
                                            <td>
                                                <button v-if="$store.state.item.status == 'criacao'"
                                                    class="btn btn-danger btn-sm"
                                                    @click="removeItem(index, item.lan_desc_id, item.id)">Remover</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="load_update" class="overlay">
            <div class="spinner">Processando...</div>
        </div>
    </div>
</template>

<script>
import * as XLSX from "xlsx";
export default {
    props: ['nivelacesso', 'rateiosalvar'],
    watch: {
        rateiosalvar() {
            this.salvarTodosRegistros()
        }
    },
    data() {
        return {
            searchQuery: '',
            searchResults: [],
            selectedItems: [],
            load_update: false,
            exibirElementoRateio: false
        };
    },
    methods: {
        exportarXLSX(data) {
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Planilha");

            XLSX.writeFile(workbook, "dados.xlsx");
        },
        getFormattedDate() {
            const d = new Date();

            const year = d.getFullYear();
            // getMonth() retorna 0-11, precisa adicionar 1
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const hours = String(d.getHours()).padStart(2, '0');
            const minutes = String(d.getMinutes()).padStart(2, '0');
            const seconds = String(d.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        async statusLancamentoRat() {
            let confirmacao = confirm('Após confirmar não será mais possvível editar!')

            if (!confirmacao) return false

            let number = typeof this.$store.state.item.valor_comprovante === 'string' ? parseFloat(this.$store.state.item.valor_comprovante.replace(/\./g, '').replace(',', '.')) : this.$store.state.item.valor_comprovante;
 
            // Formata para moeda brasileira (R$ 1.000,00)
            number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            if (number != parseFloat(this.$store.state.somaRateio.toFixed(2))) {
                alert('A soma do rateio precisa ser igual ao valor do comprovante!')
                return
            }

            await this.salvarTodosRegistros()

            let formData = new FormData() 
            formData.append('_method', 'patch')
            formData.append('status', 'pendente')
            formData.append('created_at', this.getFormattedDate())
            formData.append('caps_id', this.$store.state.item.caps_id)

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            this.load_update = true 
            axios.post('https://contasmoradores.candido.org.br/api/v1/lan_descricao' + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = ''
                    this.$store.state.status = 'pendente'
                })
                .catch(errors => {
                    console.log(errors.response.data)
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                    this.load_update = false
                })
                .finally(() => {
                    this.load_update = false
                })
        },
        async fetchResults() {
            if (this.searchQuery.length < 2) {
                this.searchResults = [];
                return;
            }

            // Busca nos pacientes já carregados no store
            const searchTerm = this.searchQuery.toLowerCase();
            const allPatients = this.$store.state.pacientes || [];

            this.searchResults = allPatients.filter(patient =>
                patient.nome.toLowerCase().includes(searchTerm)
            );
        },
        async carregarRateiosExistentes() {
            if (!this.$store.state.item.id) return
            try {
                const response = await axios.get(`https://contasmoradores.candido.org.br/api/v1/lancamento?filtro=lan_desc_id:=:${this.$store.state.item.id}`);

                this.selectedItems = response.data.map(item => ({
                    id: item.id,
                    nome: item.nome_paciente,
                    cod_conta_caixa_paciente: item.cod_conta_caixa_paciente,
                    centro_custo: item.centro_custo_paciente,
                    valor_rateio_paciente: item.valor_paciente,
                    lan_desc_id: item.lan_desc_id
                }));
                this.calcularSomaRateio();
                this.exibirElementoRateio = true
            } catch (error) {
                console.error("Erro ao carregar rateios existentes:", error);
            }
        },
        addToTable(item) {
            if (!this.selectedItems.some(i => i.nome === item.nome)) {
                this.selectedItems.push({ ...item, valor_rateio_paciente: 0.00 });
            }

            this.searchResults = [];
            this.searchQuery = '';
            this.calcularSomaRateio();
        },
        removeItem(index, lan_desc_id, id) {

            if (!lan_desc_id) {
                this.selectedItems.splice(index, 1);
                this.calcularSomaRateio();
                return
            }

            let confirmacao = confirm('Confirmar remoção do registro!')

            if (!confirmacao) return false

            let formData = new FormData()
            formData.append('_method', 'delete')

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/lancamento' + '/' + id, formData, config)
                .then(response => {
                    this.carregarRateiosExistentes();
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        calcularSomaRateio() {
            // Calcula a soma dos valores de rateio, convertendo para número corretamente
            const soma = this.selectedItems.reduce((total, item) => {
                // Converte a string formatada para número, se necessário
                const valor = this.converterParaNumero(item.valor_rateio_paciente) || 0;
                return total + valor;
            }, 0); // Valor inicial do acumulador é 0

            // Atualiza o estado do Vuex com a soma calculada
            this.$store.commit('setSomaRateio', soma);
        },
        converterParaNumero(valor) {
            if (!valor) return 0; // Retorna 0 se for vazio ou null

            if (typeof valor === 'number') return valor; // Se já for número, retorna direto

            // Remove pontos (separadores de milhar) e troca vírgula por ponto
            valor = valor.replace(/\./g, '').replace(',', '.');

            return parseFloat(valor) || 0;
        },
        aplicarMascaraLanRat(event, item) {
            let valor = event.target.value;

            // Remove todos os caracteres que não são números
            valor = valor.replace(/\D/g, '');

            // Se estiver vazio, evita erro e mantém a string vazia
            if (valor === '') {
                item.valor_rateio_paciente = '';
                return;
            }

            // Converte para número e divide por 100 para formatar como decimal
            valor = (parseInt(valor, 10) / 100).toFixed(2);

            // Formata o valor no padrão brasileiro (vírgula decimal, pontos para milhar)
            valor = valor.replace('.', ',');
            valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

            // Atualiza o valor no item do array
            item.valor_rateio_paciente = valor;

            // Atualiza a interface do input
            this.$nextTick(() => {
                event.target.value = valor;
            });

            // Atualiza a soma do rateio
            this.calcularSomaRateio();
        },
        async salvarTodosRegistros() {
            if(!this.selectedItems || this.selectedItems.length < 1) return
            this.load_update = true;
            let erros = [];

            try {
                // Separar registros novos e existentes
                const novosRegistros = this.selectedItems.filter(item => !item.lan_desc_id);
                const registrosExistentes = this.selectedItems.filter(item => item.lan_desc_id);


                // Salvar novos registros
                if (novosRegistros.length) {
                    const errosNovos = await this.salvarRegistro(novosRegistros);
                    erros.push(...errosNovos);
                }

                // Atualizar registros existentes
                if (registrosExistentes.length) {
                    const errosExistentes = await this.atualizarRegistro(registrosExistentes);
                    erros.push(...errosExistentes);
                }

                await this.carregarRateiosExistentes();

                if (erros.length) {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: `Foram encontrados ${erros.length} erros ao salvar registros.`,
                        dados: erros
                    }
                } else {
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = 'Registros salvos com sucesso!'
                }
            } catch (err) {
                this.$store.state.transacao.status = 'erro'
                this.$store.state.transacao.mensagem = {
                    mensagem: `Erro inesperado em salvarTodosRegistros: ${err}`,
                    dados: err
                }
                this.load_update = false;
            } finally {
                this.load_update = false;
            }
        },

        async salvarRegistro(registros) {
            let erros = [];
            const promises = registros.map(registro => {
                let formData = new FormData()

                formData.append('nome_paciente', registro.nome)
                formData.append('cod_conta_caixa_paciente', registro.conta_contabil_reduzido)
                formData.append('centro_custo_paciente', registro.centro_custo)
                formData.append('valor_paciente', registro.valor_rateio_paciente)
                formData.append('historico_paciente', '0040')
                formData.append('lan_desc_id', this.$store.state.item.id)

                let config = {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': this.token
                    }
                }

                return axios.post('https://contasmoradores.candido.org.br/api/v1/lancamento', formData, config)
                    .catch(error => {
                        console.log(error.response.data)
                        erros.push({ registro, error });
                    });
            });

            await Promise.all(promises);
            return erros;
        },

        async atualizarRegistro(registros) {
            let erros = [];
            const promises = registros.map(registro => {

                let formData = new FormData();
                formData.append('_method', 'patch')
                formData.append('nome_paciente', registro.nome)
                formData.append('cod_conta_caixa_paciente', registro.cod_conta_caixa_paciente)
                formData.append('centro_custo_paciente', registro.centro_custo)
                formData.append('valor_paciente', registro.valor_rateio_paciente)
                formData.append('historico_paciente', '0040')
                formData.append('id', registro.id)
                formData.append('lan_desc_id', this.$store.state.item.id)

                let config = {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': this.token
                    }
                };

                return axios.post(`https://contasmoradores.candido.org.br/api/v1/lancamento/${registro.id}`, formData, config)
                    .catch(error => {
                        erros.push({ registro, error });
                        console.log(error.response.data)
                    });
            });

            await Promise.all(promises);
            return erros;
        },

    },
    mounted() {

    },
    computed: {
        styleRateio() {
            if (this.nivelacesso == 'user' && this.$store.state.item.status != 'criacao') {
                return 'pointer-events: none; mix-blend-mode: multiply'
            }
            if (this.nivelacesso == 'adm' && this.$store.state.item.status != 'taxa') {
                return 'pointer-events: none; mix-blend-mode: multiply'
            }
        }
    }
}
</script>

<style scoped>
.list-group-item {
    cursor: pointer;
}


.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(270deg, #ff6b6b, #feca57, #48dbfb, #1dd1a1);
    background-size: 800% 800%;
    animation: gradientAnimation 10s ease infinite;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    opacity: 0.6;
}

.spinner {
    color: #000;
    font-size: 1.5rem;
    font-weight: bold;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

@keyframes gradientAnimation {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}
</style>
